import { render, staticRenderFns } from "./TransactionHistoryPlaceholder.vue?vue&type=template&id=575a4a98&scoped=true&"
import script from "./TransactionHistoryPlaceholder.vue?vue&type=script&lang=js&"
export * from "./TransactionHistoryPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./TransactionHistoryPlaceholder.vue?vue&type=style&index=0&id=575a4a98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575a4a98",
  null
  
)

export default component.exports